import { useCallback } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import {
   Link,
   LinkSize,
   Notification,
   NotificationSize,
   NotificationType,
   useHistoryPushWithBackAction,
} from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { getDocplannerIntegrationPath } from '~legacy.p1';
import { useGetCurrentHealthcareProviderType } from '~libs.shared.account';

import { personnelTranslationKeys } from '../../../translations';

const StyledDocplannerIntegrationSettingsLink = styled(Link)`
   display: inline;
`;

const DocplannerIntegrationSettingsLink = (): JSX.Element => {
   const healthcareProviderType = useGetCurrentHealthcareProviderType();
   const push = useHistoryPushWithBackAction(true);
   const goToDocplannerIntegrationSettings = useCallback(() => {
      push(getDocplannerIntegrationPath(healthcareProviderType), {});
   }, [push, healthcareProviderType]);
   return (
      <StyledDocplannerIntegrationSettingsLink
         testId={'goToDocplannerIntegrationSettings'}
         onClick={goToDocplannerIntegrationSettings}
         label={personnelTranslationKeys.docplannerIntegrationSettings}
         size={LinkSize.SMALL}
      />
   );
};

export const DocplannerServicesInformationNotification = (): JSX.Element | null => {
   return protectFeature(
      'managingDocplannerSlots',
      <Notification
         testId={'docplannerServicesInformation'}
         type={NotificationType.INFO}
         size={NotificationSize.SMALLER}
         label={protectFeature(
            'managingDocplannerIntegration',
            <Trans
               i18nKey={personnelTranslationKeys.docplannerServicesInformationForAdmin}
               components={{
                  docplannerIntegrationSettingsLink: <DocplannerIntegrationSettingsLink />,
               }}
            />,
            personnelTranslationKeys.docplannerServicesInformationForNonAdmin
         )}
      />,
      null
   );
};
